<template>
    <div class="tab-pane" :class="{'active' : user_type=='0'}" id="student_detail_tab" aria-labelledby="student-detail-tab">
        <div class="form-group row">
            <div class="card-body">
            <div class="row form-group">
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <strong>Name: </strong> {{name}}
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <strong>BCSE-X 2021 Index Number: </strong> {{index_number}}
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <strong>Student Code: </strong> {{student_code}}
                </div>
            </div>
            <h5 class="mt-6">
                <strong>Academic Information</strong>
            </h5>
            <hr class="mt-0">
            <div class="row form-group">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for="name" class="form-label">Student Marks:</label>
                <table class="table table-bordered table-striped" id="subject">
                        <thead>
                            <tr>
                                <th></th>
                                <th>English</th>
                                <th>Dzongkha</th>
                                <th>History</th>
                                <th>Civics</th>
                                <th>Mathematics</th>
                                <th>Chemistry</th>
                                <th>Biology</th>
                                <th>Elective</th>
                                <th>Percentage 
                                    (English+Best Four)
                                </th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index ) in marksheet" :key="index">
                                <td><strong>Score</strong></td>
                                <td class="text-right">{{item.english}}</td>
                                <td class="text-right">{{item.dzongkha}}</td>
                                <td class="text-right">{{item.history}}</td>
                                <td class="text-right">{{item.civics}}</td>
                                <td class="text-right">{{item.mathematics}}</td>
                                <td class="text-right">{{item.chemistry}}</td>
                                <td class="text-right">{{item.biology}}</td>
                                <td class="text-right">{{item.elective}}</td>
                                <td class="text-right">{{item.percentage}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
             </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            user_type:'',
            name:'',
            gender:'',
            index_number:'',
            student_code:'',
            marksheet:[]
        }
    },
    methods:{
        getUserDetails(user_id){
            axios.get('user/getUser/'+user_id)
            .then(response =>{ 
                let detail = response.data.student_details[0]
                this.name = detail['name'];
                this.gender = detail['gender'];
                this.index_number = detail['std_indexno'];
                this.student_code = detail['student_code'];
                this.marksheet = response.data.student_marks
            })
            .catch(error => console.log(error));
        },
    },
    mounted(){
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.user_type=data['role'];
            this.getUserDetails(data['id']);
        })
    }
    
}
</script>